import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Plug, MapPin, Tag, Bell, Users, Plus, RefreshCw } from 'lucide-react';
interface SettingsDashboardProps {
  onRunWizard: () => void;
}
export function SettingsDashboard({
  onRunWizard
}: SettingsDashboardProps) {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-3224">
      <div className="flex justify-between items-center" data-id="element-3225">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-3226">
          Setup & Configuration
        </h1>
        <Button variant="secondary" onClick={onRunWizard} data-id="element-3227">
          Run Wizard Again
        </Button>
      </div>

      <div className="space-y-6" data-id="element-3228">
        {/* DATA SOURCES */}
        <Card data-id="element-3229">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-3230">
            <Plug className="text-accent-primary" data-id="element-3231" />
            <h3 className="font-bold text-lg" data-id="element-3232">Data Sources</h3>
          </div>

          <div className="space-y-4" data-id="element-3233">
            <div className="flex items-center justify-between p-4 bg-white/5 rounded-lg" data-id="element-3234">
              <div data-id="element-3235">
                <div className="font-bold flex items-center gap-2" data-id="element-3236">
                  Wolt API{' '}
                  <span className="text-xs bg-accent-success/20 text-accent-success px-2 py-0.5 rounded-full" data-id="element-3237">
                    ● Connected
                  </span>
                </div>
                <div className="text-sm text-text-secondary mt-1 flex items-center gap-2" data-id="element-3238">
                  <RefreshCw size={12} data-id="element-3239" /> Last sync: 5 min ago
                </div>
              </div>
              <Button size="sm" variant="secondary" data-id="element-3240">
                Disconnect
              </Button>
            </div>

            <div className="flex items-center justify-between p-4 bg-white/5 rounded-lg" data-id="element-3241">
              <div data-id="element-3242">
                <div className="font-bold flex items-center gap-2" data-id="element-3243">
                  Collina.rs{' '}
                  <span className="text-xs bg-accent-success/20 text-accent-success px-2 py-0.5 rounded-full" data-id="element-3244">
                    ● Connected
                  </span>
                </div>
                <div className="text-sm text-text-secondary mt-1 flex items-center gap-2" data-id="element-3245">
                  <RefreshCw size={12} data-id="element-3246" /> Last sync: 12 min ago
                </div>
              </div>
              <Button size="sm" variant="secondary" data-id="element-3247">
                Disconnect
              </Button>
            </div>

            <Button variant="secondary" className="w-full border-dashed border-white/20" icon={<Plus size={16} data-id="element-3249" />} data-id="element-3248">
              Add Data Source
            </Button>
          </div>
        </Card>

        {/* LOCATIONS */}
        <Card data-id="element-3250">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-3251">
            <MapPin className="text-accent-primary" data-id="element-3252" />
            <h3 className="font-bold text-lg" data-id="element-3253">Locations</h3>
          </div>

          <div className="flex justify-between items-center" data-id="element-3254">
            <div data-id="element-3255">
              <div className="font-medium" data-id="element-3256">5 locations configured</div>
              <div className="text-sm text-text-secondary mt-1" data-id="element-3257">
                2 groups: Novi Beograd, Centar
              </div>
            </div>
            <Button size="sm" variant="secondary" data-id="element-3258">
              Edit
            </Button>
          </div>
        </Card>

        {/* CATEGORIES & MARGINS */}
        <Card data-id="element-3259">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-3260">
            <Tag className="text-accent-primary" data-id="element-3261" />
            <h3 className="font-bold text-lg" data-id="element-3262">Categories & Margins</h3>
          </div>

          <div className="flex justify-between items-center" data-id="element-3263">
            <div data-id="element-3264">
              <div className="font-medium" data-id="element-3265">6 categories configured</div>
              <div className="text-sm text-text-secondary mt-1" data-id="element-3266">
                Avg margin: 71.5%
              </div>
            </div>
            <Button size="sm" variant="secondary" data-id="element-3267">
              Edit
            </Button>
          </div>
        </Card>

        {/* NOTIFICATIONS */}
        <Card data-id="element-3268">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-3269">
            <Bell className="text-accent-primary" data-id="element-3270" />
            <h3 className="font-bold text-lg" data-id="element-3271">Notifications</h3>
          </div>

          <div className="space-y-4" data-id="element-3272">
            <div className="flex justify-between items-center" data-id="element-3273">
              <div data-id="element-3274">
                <div className="font-medium" data-id="element-3275">Daily summary email</div>
                <div className="text-xs text-accent-success" data-id="element-3276">● On</div>
              </div>
              <Button size="sm" variant="secondary" data-id="element-3277">
                Edit
              </Button>
            </div>
            <div className="flex justify-between items-center" data-id="element-3278">
              <div data-id="element-3279">
                <div className="font-medium" data-id="element-3280">Low stock alerts</div>
                <div className="text-xs text-accent-success" data-id="element-3281">● On</div>
              </div>
              <Button size="sm" variant="secondary" data-id="element-3282">
                Edit
              </Button>
            </div>
            <div className="flex justify-between items-center" data-id="element-3283">
              <div data-id="element-3284">
                <div className="font-medium" data-id="element-3285">Weekly report</div>
                <div className="text-xs text-text-secondary" data-id="element-3286">○ Off</div>
              </div>
              <Button size="sm" variant="secondary" data-id="element-3287">
                Edit
              </Button>
            </div>
          </div>
        </Card>

        {/* TEAM ACCESS */}
        <Card data-id="element-3288">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-3289">
            <Users className="text-accent-primary" data-id="element-3290" />
            <h3 className="font-bold text-lg" data-id="element-3291">Team Access</h3>
          </div>

          <div className="flex justify-between items-center" data-id="element-3292">
            <div data-id="element-3293">
              <div className="font-medium" data-id="element-3294">3 team members</div>
              <div className="text-sm text-text-secondary mt-1" data-id="element-3295">
                Marko (Owner), Ana (Manager), Stefan (Viewer)
              </div>
            </div>
            <Button size="sm" variant="secondary" data-id="element-3296">
              Manage
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}